import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../lib/api';

const LanguageContext = createContext();

const DICTIONARY = {
  pt: {
    // Layout
    latestNews: "Últimas Notícias",
    community: "Comunidade",
    online: "Online",
    suporte: "Suporte",
    termosLegal: "Legal",
    novoPorAqui: "Novo?",
    criarAgora: "Criar!",
    topPlayers: "Top Jogadores",
    topTournaments: "Top Torneios",
    searchPlayer: "Buscar Jogador",
    login: "Entrar",
    recoverPassword: "Recuperar Senha",
    howToPlay: "Como Jogar",
    downloadGame: "Baixar Jogo",
    wiki: "Wiki / Ajuda",
    forum: "Fórum",
    support: "Suporte",
    footerText: `© ${new Date().getFullYear()} Todos os direitos reservados.`,
    novoPorAqui: "Novo por aqui?",
    criarAgora: "Criar Agora",
    painelAdmin: "Painel Administrativo",
    verTodos: "Ver Todos",
    temaPortal: "Tema do Portal",
    online: "Online",
    // Home
    welcomeDemo: "Seja bem-vindo à demonstração",
    exploreFuture: "Explore o futuro do PKX Engine. Uma plataforma redesenhada para oferecer a melhor experiência aos treinadores.",
    playersOnline: "Jogadores Online",
    region: "Região",
    status: "Status",
    latestNews: "NOTÍCIAS RECENTES",
    viewAllNews: "Ver Todas",
    noNews: "Aguardando novas publicações...",
    readMore: "Ler Matéria",
    destaque: "Destaque",
    rankings: "Rankings",
    vejaQuem: "Veja quem são os melhores.",
    seguranca: "Segurança",
    suaConta: "Sua conta protegida.",
    vipShop: "Loja VIP",
    vantagens: "Vantagens exclusivas.",
    // Others
    level: "Nível",
    captures: "Capturas",
    name: "Nome",
    vocation: "Vocação",
    pos: "Pos"
  },
  en: {
    // Layout
    account: "Account",
    community: "Community",
    topPlayers: "Top Players",
    topTournaments: "Top Tournaments",
    searchPlayer: "Search Player",
    login: "Login",
    recoverPassword: "Recover Password",
    howToPlay: "How to Play",
    downloadGame: "Download Game",
    wiki: "Wiki / Help",
    forum: "Forum",
    support: "Support",
    footerText: `© ${new Date().getFullYear()} All rights reserved.`,
    novoPorAqui: "New here?",
    criarAgora: "Create Now",
    painelAdmin: "Admin Panel",
    verTodos: "View All",
    temaPortal: "Portal Theme",
    online: "Online",
    // Home
    welcomeDemo: "Welcome to the demonstration",
    exploreFuture: "Explore the future of PKX Engine. A platform redesigned to offer the best experience to trainers.",
    playersOnline: "Players Online",
    region: "Region",
    status: "Status",
    latestNews: "LATEST NEWS",
    viewAllNews: "View All",
    noNews: "Waiting for new publications...",
    readMore: "Read More",
    destaque: "Featured",
    rankings: "Rankings",
    vejaQuem: "See who's the best.",
    seguranca: "Security",
    suaConta: "Your account protected.",
    vipShop: "VIP Shop",
    vantagens: "Exclusive advantages.",
    // Others
    level: "Level",
    captures: "Captures",
    name: "Name",
    vocation: "Vocation",
    pos: "Pos"
  },
  es: {
    // Layout
    account: "Cuenta",
    community: "Comunidad",
    topPlayers: "Top Jugadores",
    topTournaments: "Torneos",
    searchPlayer: "Buscar Jugador",
    login: "Entrar",
    recoverPassword: "Recuperar Contraseña",
    howToPlay: "Como Jugar",
    downloadGame: "Descargar Juego",
    wiki: "Wiki / Ayuda",
    forum: "Foro",
    support: "Soporte",
    footerText: `© ${new Date().getFullYear()} Todos los derechos reservados.`,
    novoPorAqui: "¿Nuevo por aquí?",
    criarAgora: "Crear Ahora",
    painelAdmin: "Panel de Administración",
    verTodos: "Ver Todos",
    temaPortal: "Tema del Portal",
    online: "En línea",
    // Home
    welcomeDemo: "Bienvenido a la demostración",
    exploreFuture: "Explore el futuro de PKX Engine. Una plataforma rediseñada para ofrecer la mejor experiencia a los entrenadores.",
    playersOnline: "Jugadores en línea",
    region: "Región",
    status: "Estado",
    latestNews: "NOTICIAS RECIENTES",
    viewAllNews: "Ver Todas",
    noNews: "Esperando nuevas publicaciones...",
    readMore: "Leer Más",
    destaque: "Destacado",
    rankings: "Rankings",
    vejaQuem: "Mira quiénes são los mejores.",
    seguranca: "Seguridad",
    suaConta: "Tu cuenta protegida.",
    vipShop: "Tienda VIP",
    vantagens: "Ventajas exclusivas.",
    // Others
    level: "Nivel",
    captures: "Capturas",
    name: "Nombre",
    vocation: "Vocación",
    pos: "Pos"
  },
  pl: {
    // Layout
    account: "Konto",
    community: "Społeczność",
    topPlayers: "Najlepsi gracze",
    topTournaments: "Turnieje",
    searchPlayer: "Szukaj gracza",
    login: "Zaloguj się",
    recoverPassword: "Odzyskaj hasło",
    howToPlay: "Jak grać",
    downloadGame: "Pobierz grę",
    wiki: "Wiki",
    forum: "Forum",
    support: "Pomoc",
    footerText: `© ${new Date().getFullYear()} Wszelkie prawa zastrzeżone.`,
    novoPorAqui: "Jesteś tu nowy?",
    criarAgora: "Utwórz konto",
    painelAdmin: "Panel administracyjny",
    verTodos: "Zobacz wszystko",
    temaPortal: "Motyw portalu",
    online: "Online",
    // Home
    welcomeDemo: "Witamy w wersji demonstracyjnej",
    exploreFuture: "Odkryj przyszłość silnika PKX. Platforma zaprojektowana na nowo, aby oferować najlepsze wrażenia trenerom.",
    playersOnline: "Gracze online",
    region: "Region",
    status: "Status",
    latestNews: "NAJNOWSZE WIADOMOŚCI",
    viewAllNews: "Zobacz wszystkie",
    noNews: "Oczekiwanie na nowe publikacje...",
    readMore: "Czytaj więcej",
    destaque: "Wyróżnione",
    rankings: "Rankingi",
    vejaQuem: "Zobacz kto jest najlepszy.",
    seguranca: "Bezpieczeństwo",
    suaConta: "Twoje konto jest chronione.",
    vipShop: "Sklep VIP",
    vantagens: "Ekskluzywne korzyści.",
    // Others
    level: "Poziom",
    captures: "Złapane",
    name: "Nazwa",
    vocation: "Profesja",
    pos: "Poz"
  },
  fr: {
    // Layout
    account: "Compte",
    community: "Communauté",
    online: "En ligne",
    suporte: "Support",
    termosLegal: "Légal",
    novoPorAqui: "Nouveau ici ?",
    criarAgora: "Créer maintenant",
    topPlayers: "Meilleurs Joueurs",
    topTournaments: "Top Tournois",
    searchPlayer: "Chercher un Joueur",
    login: "Connexion",
    recoverPassword: "Mot de passe oublié",
    howToPlay: "Comment Jouer",
    downloadGame: "Télécharger le Jeu",
    wiki: "Wiki / Aide",
    forum: "Forum",
    support: "Support",
    footerText: `© ${new Date().getFullYear()} Tous droits réservés.`,
    painelAdmin: "Panneau d'Administration",
    verTodos: "Voir Tout",
    temaPortal: "Thème du Portail",
    // Home
    welcomeDemo: "Bienvenue sur la démonstration",
    exploreFuture: "Explorez l'avenir du moteur PKX. Une plateforme repensée pour offrir la meilleure expérience aux dresseurs.",
    playersOnline: "Joueurs en Ligne",
    region: "Région",
    status: "Statut",
    latestNews: "DERNIÈRES ACTUALITÉS",
    viewAllNews: "Voir Tout",
    noNews: "En attente de nouvelles publications...",
    readMore: "Lire la Suite",
    destaque: "En Vedette",
    rankings: "Classements",
    vejaQuem: "Découvrez qui sont les meilleurs.",
    seguranca: "Sécurité",
    suaConta: "Votre compte sécurisé.",
    vipShop: "Boutique VIP",
    vantagens: "Avantages exclusifs.",
    // Others
    level: "Niveau",
    captures: "Captures",
    name: "Nom",
    vocation: "Vocation",
    pos: "Pos"
  }
};

const LANG_CODES = ['pt', 'en', 'es', 'pl', 'fr'];

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => { const l = localStorage.getItem('lang'); return LANG_CODES.includes(l) ? l : 'pt'; });

  useEffect(() => {
    localStorage.setItem('lang', lang);
    try { document.documentElement.setAttribute('lang', lang === 'pt' ? 'pt-BR' : lang); } catch { /* ok */ }
    // traduz o site inteiro (textos que não passam pelo dicionário do React): motor em public/i18n
    try { if (window.PkxI18n) window.PkxI18n.setLang(lang); } catch { /* ok */ }
  }, [lang]);

  // trocar pela bandeira do site: vale na hora e, com login, fica salvo na CONTA (o jogo abre já nesse idioma)
  const setLang = (l) => {
    if (!LANG_CODES.includes(l)) return;
    setLangState(l);
    try {
      localStorage.setItem('lang', l);
      if (localStorage.getItem('pokeot_token')) api.post('/account/language', { lang: l }).catch(() => { });
    } catch { /* ok */ }
  };

  // ao abrir o site já logado: o idioma salvo na conta (escolhido no cadastro ou no jogo) vale aqui também
  useEffect(() => {
    let off = false;
    try {
      if (!localStorage.getItem('pokeot_token')) return undefined;
      api.get('/account/language').then((r) => {
        const l = r && r.data && r.data.lang;
        if (!off && LANG_CODES.includes(l)) { setLangState(l); localStorage.setItem('lang', l); }
      }).catch(() => { });
    } catch { /* ok */ }
    return () => { off = true; };
  }, []);

  const t = (key) => {
    return DICTIONARY[lang]?.[key] || DICTIONARY['pt'][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error('useLanguage must be used within LanguageProvider');
  return context;
};

